/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { upperFirst } from 'lodash'
import { useIntl } from 'react-intl'
import FormField, {
  FormTextFieldProps
} from '../../../../client/js/components/form/fields/FormField'

function NameField (props: FormTextFieldProps) {
  const { name = 'name', ...others } = props
  const intl = useIntl()
  return (
    <FormField
      label={intl.formatMessage({
        id: 'name',
        defaultMessage: 'Nom'
      })}
      name={name}
      parser={upperFirst}
      {...others}
    />
  )
}

export default NameField
